export default __webpack_public_path__ + "i18n/translations/translation-nb.cb0a3d78.json";